module.exports = __webpack_public_path__ + "img/tbn_slide_2.e49b7525.jpg";